// Set up the CSS style.
import "bootstrap/dist/css/bootstrap.min.css";

import WrapPageElementWithLayout from "./src/components/WrapPageElement";

// Enable i18n.
import "./src/utils/i18n";

export const wrapPageElement = WrapPageElementWithLayout;
